import { render, staticRenderFns } from "./longitudinal.vue?vue&type=template&id=32e06350&scoped=true&"
import script from "./longitudinal.vue?vue&type=script&lang=js&"
export * from "./longitudinal.vue?vue&type=script&lang=js&"
import style0 from "./longitudinal.vue?vue&type=style&index=0&id=32e06350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e06350",
  null
  
)

export default component.exports